import { lazy } from "react";
import Loadable from "app/components/Loadable";

const TimesheetList = Loadable(lazy(() => import("./TimesheetList")));
const Timesheet = Loadable(lazy(() => import("./Timesheet")));

const TimesheetRoutes = [
  { path: "/employee/timecard", element: <TimesheetList /> },
  { path: "/employee/timecard/:mode/:id", element: <Timesheet /> },
];

export default TimesheetRoutes;
